import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { OrderedSet } from 'immutable';
import { COMPANY, DEAL, TICKET } from 'customer-data-objects/constants/ObjectTypes';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import I18n from 'I18n';
const getLabelStringForAssociation = (associatedObjectType, objectType) => {
  if ((objectType === DEAL || objectType === TICKET) && associatedObjectType === COMPANY) {
    return () => I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.ASSOCIATIONS.associationscompany.label');
  }
  return undefined;
};
export default function makeAssociationField(associatedObjectType, objectType) {
  // Tickets associations do not support Known and NotKnown operators
  // https://issues.hubspotcentral.com/browse/CRM-17487
  const operators = objectType === TICKET ? OrderedSet.of(Operators.Equal, Operators.NotEqual) : OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown);
  return {
    getLabelString: getLabelStringForAssociation(associatedObjectType, objectType),
    operators,
    inputType: ENUMERATION,
    referencedObjectType: associatedObjectType
  };
}